import module from 'facturacion/configuracion/module.js'
import template from './template.html'

export class FacturacionConfiguracionConceptosEditarProductosserviciosItemComponent {
  data
  onSelect

  seleccionar () {
    this.onSelect({$event: {details: this.data}})
  }
}

module.component('facturacionConfiguracionConceptosEditarProductosserviciosItem', {
  controller: FacturacionConfiguracionConceptosEditarProductosserviciosItemComponent,
  template,
  bindings: {
    data: '<',
    onSelect: '&',
  },
})



// WEBPACK FOOTER //
// ./src/facturacion/configuracion/components/conceptos/editar/productosservicios/item/component.js